import { render, staticRenderFns } from "./AfterGameReport.vue?vue&type=template&id=6ae54294&"
import script from "./AfterGameReport.vue?vue&type=script&lang=ts&"
export * from "./AfterGameReport.vue?vue&type=script&lang=ts&"
import style0 from "./AfterGameReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports